import logo from './logo.svg';
import { Routes, Route } from "react-router"
import './App.css';
import Home from "./views/Home"
import About from "./views/About"
import Contact from "./views/Contact"
import Navbar from './components/Navbar/Navbar';
import Button from './components/Button/Button';
import ProfilePage from './views/ProfilePage';


function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="contact" element={<Contact />} />
        <Route path="profile" element={<ProfilePage/>} />
      </Routes>
      
    </div>
  );
}

export default App;
